<template>
  <TransitionBlock name="toast">
    <div v-if="visible" :class="[style.popup, style.error]">
      <IconBase :icon="alertCircleIcon" />
      <span>{{ text }}</span>
    </div>
  </TransitionBlock>
</template>

<script lang="ts">
import style from "../Toast.module.scss";
import {defineComponent} from "vue";
import TransitionBlock from "@/layout/nav/components/TransitionBlock/TransitionBlock.vue";
import alertCircleIcon from "$images/icons/toast/alert-circle16, Tone=Default.svg";
import IconBase from "@/elements/UI/icon/IconBase.vue";

export default defineComponent({
  name: "ToastError",
  components: {IconBase, TransitionBlock},
  props: {
    text: String
  },

  data() {
    return {
      style,
      alertCircleIcon,
      visible: false,
      timer: null as number | null
    };
  },

  methods: {
    show() {
      this.visible = true;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = window.setTimeout(() => {
        this.visible = false;
      }, 3000);
    }
  }
});
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  transform: translate(-50%, -40px);
  opacity: 0;
}

.toast-enter-to {
  transform: translate(-50%, 0);
  opacity: 1;
}

.toast-leave-from {
  transform: translate(-50%, 0);
  opacity: 1;
}

.toast-leave-to {
  transform: translate(-50%, -40px);
  opacity: 0;
}
</style>
